import { FormControl, IconButton, MenuItem, Select, TextareaAutosize, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { PiBagFill } from "react-icons/pi";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ArrowBack, ArrowForward, ExpandMore } from "@mui/icons-material";
import { useForm, Controller } from "react-hook-form";
import { FaRegMessage } from "react-icons/fa6";
import { MdOutlineAttachFile } from "react-icons/md";
// import IssueComments from "./IssueComments";
// import IssueTask from "./IssueTask";
// import IssueLogHours from "./IssueLogHour";
// import IssueDocument from "./IssueDocument";
// import IssueActivityStream from "./IssueActivity";
import { editProjectDetails, fetchEntityById } from "../../../apis/apiService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Slider from "react-slick";
import { extractLetters } from "../../../utils/textUtils";
import { useFetchIssueDetailViewQuery, useFetchIssueModuleDropdownQuery, useFetchIssueTimeSheetLogDetailsQuery} from "../../../slice/logdetailSlice";
// import Loader from "../../common/Loader";
import Loader from "../Loader";
import { IssueTabs } from "../../ProjectModule/issues/IssueDetail";
import { MilestoneIssueTabs } from "../../ProjectModule/milestones/issues/MilestoneIssueDetails";
import { CiCirclePlus } from "react-icons/ci";
import { skipToken } from "@reduxjs/toolkit/query";
import CommonDetailTimer from "../timer/CommonDetailTimer";
import { useTheme } from "../../../ThemeContext";
// import { useFetchIssueDetailViewQuery } from "../../../slice/logdetailSlice";


export const CommonIssueDetail = ({
  showpath,
  updatePath,
  issue_module_refetch,
  issue_detail_refetch,
  project_based_users,
  issue_refetch,
  handleBoxClick,
  project_id,
  id,
  isIssueDetail,
  isMilestoneIssueDetail,
}) => {
  const { isDarkMode } = useTheme();
  const [headanchorEl, setheadAnchorEl] = useState(null);
  const [IssueDetail, setissueDetail] = useState([]);
  const [issuelist, setIssuelist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const inputRef = useRef(null);
  const dueDateTimeoutRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [dueDateError, setDueDateError] = useState("");
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in task:", login_user);
  const [showModel, setShowModel] = useState(true);
  const {
    role: login_user_role,
    name: login_user_name,
    id: login_user_id,
  } = login_user;

  // const {
  //   data: issue_module,
  //   refetch: issue_module_refetch,
  //   isLoading: issue_module_loading,
  // } = useFetchIssueModuleQuery();
  //console.log("login_user role in task:", login_user_role);

  const [nameChange, setNameChange] = useState({
    description: "",
    assignee_id: "",
    current_status_id: null,
    due_date: null,
    priority_id: null,
    severity_id: null,
    module: "",
    title: "",
  });
  // const { data: project_based_users } =
  //   useFetchGetAllProjectBasedUserNameListQuery(project_id);
  const { data: issue_detail} = useFetchIssueDetailViewQuery(id);
  const { data: issue_module_dropdown, refetch: module_refetch } =
    useFetchIssueModuleDropdownQuery(project_id ?? skipToken, {
      refetchOnMountOrArgChange: true,
    });

  // Status option from redux
  const { data: logDetails } = useFetchIssueTimeSheetLogDetailsQuery(id);
  const calculateTotalHours = (logs) => {
    if (!logs || !Array.isArray(logs)) return "00:00";
    let totalMinutes = 0;
    logs.forEach((day) => {
      if (day.logHourse && Array.isArray(day.logHourse)) {
        const [h, m] = day.logHourse[0].split(":").map(Number);
        totalMinutes += (h || 0) * 60 + (m || 0);
      }
    });
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const totalCalculatedHours = calculateTotalHours(logDetails);
  const StatusOptions = useSelector((state) => state.selectOptions?.StatusOptions);
  const statusNames = StatusOptions.find((status) => status.status_type === "ISSUE");
  const status_list = statusNames?.status_details?.map((status) => ({
    status_id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  const priorityList = useSelector((state) => state.selectOptions?.PriorityNameOptions);
  const priorityOptions = priorityList.find((list) => list.priority_type === "ISSUE");
  //console.log("priorityOptions : ", priorityOptions);
  useSelector((state) => state.selectOptions?.userNamesByProjects);
  //console.log("reporterOptions", reporterOptions);
  const serverityOptions = useSelector((state) => state.selectOptions.SeverityNameOptions);
  //console.log("serverityOptions", serverityOptions);
  const navigate = useNavigate();
  const location = useLocation();
  // If navigated from Task Issues tab, use the task-scoped issue list
  const taskIssueList = location.state?.taskIssueList ?? null;

  const { handleSubmit, control, watch } = useForm({defaultValues: {},});
  const formValues = watch();
  const previousValues = useRef(formValues);

  const routeParams = useParams();
  const handleBackClick = () => {
    if (isMilestoneIssueDetail) {
      navigate(`/projects/projectDetail/${routeParams.project_id}/milestone/MilestoneDetail/${routeParams.milestone_id}`);
    } 
    else {
      navigate(-1);
    }
  };

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };
  const HeadhandleClose = () => {
    setheadAnchorEl(null);
  };

  // Fetch detail Api call
  useEffect(() => {
    if (issue_detail) {
      setissueDetail(issue_detail);
    }
  }, [issue_detail]);

  const onSubmit = (data) => {
    // //console.log(data);
  };

  // Fetch All issues Api call
  const fetchIssuelist = async () => {
    // If task-scoped issues were passed via route state, use them directly
    if (taskIssueList) {
      // Map to the shape expected by the slider (issue_id, title, assignee_name)
      const mapped = taskIssueList.map((item) => ({
        issue_id: item.issue_id ?? item.id,
        title: item.title,
        assignee_name: item.assignee ?? item.assignee_name ?? "",
        added_by: item.added_by,
      }));
      setIssuelist(mapped);
      return;
    }
    setLoading(true);

    try {
      const response = await fetchEntityById(showpath, project_id);
      setIssuelist(response?.issues);
      //console.log(issuelist, "Issuelist");
    } 
    catch (err) {
      // Show error in toast
      toast.error(err.message || "Failed to fetch subtasks");
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIssuelist();
  }, [id]);
  // detail page edit api call

  // Comparsation of field change
  useEffect(() => {
    if (login_user_role !== "CLIENT") {
      // Restrict API update for clients
      const hasChanges = Object.keys(formValues).some(
        (key) => formValues[key] !== previousValues.current[key]
      );

      if (hasChanges) {
        previousValues.current = formValues;
      }
    }
  }, [formValues]);

  useEffect(() => {
    if (IssueDetail) {
      setNameChange({
        description: IssueDetail?.description ?? "", // ✅ Ensure empty descriptions are respected
        assignee_id: IssueDetail?.assignee_id ?? "",
        current_status_id: IssueDetail?.current_status_id ?? "",
        due_date: IssueDetail?.due_date ?? null,
        priority_id: IssueDetail?.priority_id ?? "",
        severity_id: IssueDetail?.severity_id ?? "",
        module: IssueDetail?.module ?? "",
        title: IssueDetail?.title,
      });
    } 
    else {
      // ✅ Reset state when IssueDetail is null (to prevent stale values)
      setNameChange({
        description: "",
        assignee_id: "",
        current_status_id: null,
        due_date: null,
        priority_id: null,
        severity_id: null,
        module: "",
        title: IssueDetail?.title,
      });
    }
  }, [IssueDetail, IssueDetail?.issue_id]); // ✅ Ensure it updates when issue changes

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    // console.log("name :", name, "value :", value);

    setNameChange((prev) => ({ ...prev, [name]: value }));
  };
  const handleBlur = async (e) => {
    //console.log("changed_value event: ", e);

    const { name, value } = e.target;
    setLoading(true);
    setIsEditing(false);
    //console.log("changed_value _blur :", name, value);
    const finalValue = (name === "description" && value.trim() === "") ? " " : value;
    const requestedData = {
      [name]: finalValue,
    };

    try {
      const response = await editProjectDetails(updatePath,IssueDetail?.issue_id, requestedData);
      //console.log("API call successful:", response);
      toast.success(response.message);
      issue_detail_refetch();
      issue_module_refetch();
      fetchIssuelist();
      module_refetch();
      // if (response?.status) {
      //   // Assuming response contains status and issues as per the API doc
      //   setissueDetail(response.issues);  // Set the issue details based on the response structure
      // }
    } 
    catch (error) {
      console.error("Error during API call:", error);
      toast.error(error.message || "Failed to update issue details");
    } 
    finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (IssueDetail) {
  //     //console.log("assignee :", IssueDetail.assignee);

  //     const DueDate = dayjs(IssueDetail.due_date);
  //     // Manually set form values based on projectDetail
  //     setValue("description", IssueDetail.description);
  //     setValue("Assignee", IssueDetail.assignee_name);
  //     setValue("current_status_id", IssueDetail.current_status_id);
  //     setValue("due_date", DueDate);
  //     setValue("priority_id", IssueDetail.priority_id);
  //     setValue("severity_id", IssueDetail.severity_id);
  //     setValue("module", IssueDetail.module);
  //   }
  // }, [IssueDetail, setValue]);
  //  Handel list show onclick
  const sliderRef = useRef(null);
  // const handleBoxClick = (issue_id) => {
  //   // Reset the state before navigating

  //   navigate(
  //     `/projects/projectDetail/${project_id}/issue/IssueDetail/${issue_id}`
  //   );
  // };

  // Slider setting
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: Math.min(5, issuelist.length),
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
  };

  // const handlePrevClick = () => {
  //   if (sliderRef.current) {
  //     sliderRef.current.slickPrev();
  //   }
  // };
  // const handleNextClick = () => {
  //   if (sliderRef.current) {
  //     sliderRef.current.slickNext();
  //   }
  // };

  const handlePrevClick = () => {
    if (
      sliderRef.current &&
      typeof sliderRef.current.slickPrev === "function"
    ) {
      sliderRef.current.slickPrev();
    } 
    else {
      console.warn("Slick slider is not ready yet");
    }
  };

  const handleNextClick = () => {
    if (
      sliderRef.current &&
      typeof sliderRef.current.slickNext === "function"
    ) {
      sliderRef.current.slickNext();
    } 
    else {
      console.warn("Slick slider is not ready yet");
    }
  };

  useEffect(() => {
    if (!issuelist) return;
    // Find the first matching task and update the state once
    const matchedTask = issuelist.find(
      (list) => list.added_by === issue_detail?.added_by
    );

    if (matchedTask) {
      setSelectedUser(matchedTask.added_by);
    }
  }, [issuelist, issue_detail]);

  // ✅ Check if current logged-in user is allowed to edit this issue
  // Access is granted to: ADMIN, MANAGER, the Assignee (by ID), or the Reporter/Creator (by ID)
  const canEditIssue =
    ["ADMIN", "MANAGER"].includes(login_user_role) ||
    login_user_id === issue_detail?.assignee_id ||
    login_user_id === issue_detail?.added_by;

  // Find current task index
  const currentIndex = issuelist?.findIndex(
    (issue) => issue.issue_id?.toString() === IssueDetail?.issue_id?.toString()
  );

  const handlePrevTaskNav = () => {
    if (currentIndex > 0) {
      const prevIssueId = issuelist[currentIndex - 1]?.issue_id;
      navigate(`/projects/projectDetail/${project_id}/issue/IssueDetail/${prevIssueId}`);
    }
  };

  const handleNextTaskNav = () => {
    if (currentIndex < issuelist.length - 1) {
      const nextIssueId = issuelist[currentIndex + 1]?.issue_id;
      navigate(`/projects/projectDetail/${project_id}/issue/IssueDetail/${nextIssueId}`);
    }
  };

  useEffect(() => {
    if (sliderRef.current && currentIndex >= 0) {
      sliderRef.current.slickGoTo(currentIndex);
    }
  }, [issuelist, IssueDetail]);

  //console.log("issue_detail name :", issue_detail);
  //console.log("ouser_s id :", selectedUser, login_user_id);
  const handleEditClick = () => {
    setIsEditing(true);
    setTimeout(() => {
      inputRef.current?.focus(); // Step 2: Focus the input after state update
    }, 0);
  };

  // New helper function
  function renderHTMLContent(htmlString, options = { plainText: true }) {
    if (!htmlString) return "";

  // Create a temporary DOM element
  // const tempDiv = document.createElement("div");
  // tempDiv.innerHTML = htmlString;

    if (options.plainText) {
      // Replace common block tags with newlines to preserve formatting
      // * This is for displaying the Issue View details exactly as typed in the Issue Description.
      let formattedString = htmlString
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<\/div>/gi, "\n")
        .replace(/<li>/gi, "\n• "); // Added bullet points for lists

      // Create a temporary DOM element to strip remaining HTML tags
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = formattedString;
      return tempDiv.textContent || tempDiv.innerText || "";
    } 
    else {
    // Return HTML safely (you can use this with dangerouslySetInnerHTML)
    // return tempDiv.innerHTML;
      return htmlString;
    }
  }

  return (
    <>
      {" "}
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div
            className="d-flex justify-content-between align-items-center bg-white mb-3 p-3 border-bottom rounded-bottom"
            style={{ position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="d-flex align-items-center gap-3">
              <button className="R_btn me-2" onClick={handleBackClick}>
                <IoIosArrowBack className="text-rgba-gray" size={17} />
              </button>
              
              <label className="text-rgba-gray m-0 d-flex align-items-center gap-1" 
                     style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
                <PiBagFill className="text-rgba-gray me-1" 
                     style={{ color: isDarkMode ? "#a0aec0" : undefined }} />
                Project Name: 
                <span 
                     className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>
                      {extractLetters(IssueDetail?.project_title)}
                </span>
              </label>

              <span 
                 className="text-rgba-gray border-start ps-3 py-1" 
                 style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
                Issue Name: 
                <span 
                 className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>
                  {extractLetters(nameChange.title || IssueDetail?.title)}
                </span>
              </span>

              {IssueDetail?.assignee_name && (
                <span 
                className="text-rgba-gray border-start ps-3 py-1" 
                style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
                  Assignee Name: 
                  <span 
                  className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>
                    {IssueDetail.assignee_name}
                  </span>
                </span>
              )}
            </div>

            <div className={`d-flex align-items-center border rounded-3 overflow-hidden ${isDarkMode ? "" : "bg-white"}`} 
            style={{ borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#e5e7eb', backgroundColor: isDarkMode ? 'transparent' : undefined }}>
              <style>{`
                .header-icon-item {
                  cursor: pointer;
                  transition: background-color 0.2s ease;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 8px 16px;
                  text-decoration: none;
                }
                .header-icon-item:hover {
                  background-color: ${isDarkMode ? "rgba(255, 255, 255, 0.15)" : "#f3f4f6"};
                }
              `}</style>

              {/* Comments */}
              <div
                className="header-icon-item border-end"
                style={{ borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#e5e7eb' }}
                onClick={() => {
                  const tabEl = document.getElementById("Comments-tab");
                  if (tabEl) tabEl.click();
                }}
              >
                <FaRegMessage className="text-rgbr-blue me-1" />
                <span className="text-rgba-gray">
                  ({IssueDetail?.comment_count || 0})
                </span>
              </div>

              {/* Documents */}
              <div
                className={`header-icon-item ${canEditIssue ? 'border-end' : ''}`}
                style={{ borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#e5e7eb' }}
                onClick={() => {
                  const tabEl = document.getElementById("Documents-tab");
                  if (tabEl) tabEl.click();
                }}
              >
                <MdOutlineAttachFile className="text-rgbr-blue me-1" />
                <span className="text-rgba-gray">
                  ({IssueDetail?.document_count || 0})
                </span>
              </div>

              {/* Timer */}
              {canEditIssue && (
                <div className="header-icon-item">
                  <CommonDetailTimer
                    user_id={login_user_id}
                    issue_id={id}
                    project_id={project_id}
                    isIssueDetail={true}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="row bg-white p-3">
            <div className="col-md-9">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <form onSubmit={handleSubmit(onSubmit)} className="pe-5">
                  <div className="row">
                    <div className="col-md-12 pb-3">
                      <label htmlFor="description" className="form-label">
                        Description
                      </label>
                      <Controller
                        name="description"
                        control={control}
                        disabled={login_user_role === "CLIENT"}
                        render={({ field }) => (
                          <TextareaAutosize
                            {...field}
                              value={renderHTMLContent(nameChange.description, { plainText: true })}

                            onChange={handleNameChange}
                            onBlur={handleBlur}
                            minRows={4} // Minimum height
                            maxRows={10} // Maximum height before scrolling
                            placeholder="Enter description"
                            className="textAreaField"
                            disabled={!canEditIssue}
                          />
                        )}
                      />
                    </div>

                    <div className="col-md-4 pb-3">
                      <label htmlFor="Assignee" className="form-label">
                        Assignee
                      </label>
                      <FormControl fullWidth>
                        <Controller
                          name="assignee_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              value={nameChange.assignee_id}
                              onChange={handleNameChange}
                              onBlur={handleBlur}
                              IconComponent={ExpandMoreIcon}
                              displayEmpty
                              disabled={!canEditIssue}
                            >
                              {project_based_users?.map((user, index) => (
                                <MenuItem key={index} value={user.user_id}>
                                  {user.name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </div>
                    
                    <div className="col-md-4 pb-3">
                      <label htmlFor="current_status_id" className="form-label">
                        Status
                      </label>
                      <FormControl fullWidth>
                        <Controller
                          name="current_status_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              // value={field.value || ""}
                              value={nameChange.current_status_id}
                              onChange={handleNameChange}
                              onBlur={handleBlur}
                              IconComponent={ExpandMoreIcon}
                              displayEmpty
                              renderValue={(selected) => {
                                const selected_value = status_list?.find(
                                  (status) => status.status_id === selected
                                );
                                //console.log("selected_value :", selected_value);

                                return selected_value ? (
                                  <span
                                    style={{
                                      color: selected_value.status_colour,
                                    }}
                                  >
                                    {selected_value.status_name}
                                  </span>
                                ) : (
                                  <span className=" lightText">
                                    Select status
                                  </span>
                                );
                              }}
                              disabled={!canEditIssue}
                            >
                              {status_list?.map((status) => (
                                <MenuItem
                                  key={status.status_id}
                                  value={status.status_id}
                                  sx={{
                                    color: status.status_colour || "black",
                                  }}
                                >
                                  {status.status_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="DueDate" className="form-label">
                        Due Date
                      </label>
                      <div className="d-flex  flex-column w-100">
                        <Controller
                          name="due_date"
                          control={control}
                          render={({ field }) => (
                            <>
                              <DatePicker
                                format="DD/MM/YYYY"
                                value={
                                  nameChange.due_date
                                    ? dayjs(nameChange.due_date)
                                    : null
                                }
                                onChange={(date) => {
                                  if (dueDateTimeoutRef.current) {
                                    clearTimeout(dueDateTimeoutRef.current);
                                    dueDateTimeoutRef.current = null;
                                  }

                                  if (!date) {
                                    setDueDateError("");
                                    setNameChange((prev) => ({
                                      ...prev,
                                      due_date: null,
                                    }));
                                    return;
                                  }

                                  const d = dayjs(date);
                                  const localVal = d.isValid() ? d.format("YYYY-MM-DD") : date;

                                  if (!d.isValid() || d.year() < 1990) {
                                    setDueDateError("Invalid date format");
                                    
                                    setNameChange((prev) => ({
                                      ...prev,
                                      due_date: localVal,
                                    }));

                                    if (d.isValid() && d.year() >= 1000 && d.year() < 1990) {
                                      dueDateTimeoutRef.current = setTimeout(() => {
                                        const prevDate = IssueDetail?.due_date || null;
                                        setNameChange((prev) => ({
                                          ...prev,
                                          due_date: prevDate,
                                        }));
                                        setDueDateError("");
                                      }, 3000);
                                    }
                                    return;
                                  }

                                  setDueDateError("");
                                  setNameChange((prev) => ({
                                    ...prev,
                                    due_date: localVal,
                                  }));
                                  handleBlur({
                                    target: {
                                      name: "due_date",
                                      value: localVal,
                                    },
                                  });
                                }}
                                disabled={!canEditIssue}
                                renderInput={(params) => {
                                  const originalOnBlur = params.onBlur || params.inputProps?.onBlur;
                                  return (
                                    <input
                                      className="form-control datepic_ip"
                                      {...params}
                                      onBlur={(e) => {
                                        if (originalOnBlur) originalOnBlur(e);
                                        
                                        if (dueDateTimeoutRef.current) {
                                          clearTimeout(dueDateTimeoutRef.current);
                                          dueDateTimeoutRef.current = null;
                                        }

                                        const val = nameChange.due_date;
                                        if (val) {
                                          const d = dayjs(val);
                                          if (!d.isValid() || d.year() < 1990) {
                                            const prevDate = IssueDetail?.due_date || null;
                                            setNameChange((prev) => ({
                                              ...prev,
                                              due_date: prevDate,
                                            }));
                                          }
                                        }
                                        setDueDateError("");
                                      }}
                                    />
                                  );
                                }}
                              />
                              {dueDateError && (
                                <span className="errorMsg">
                                  {dueDateError}
                                </span>
                              )}
                            </>
                          )}
                        />
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="Priority" className="form-label">
                        Priority
                      </label>
                      <Controller
                        name="priority_id"
                        control={control}
                        render={({ field }) => (
                          <FormControl fullWidth>
                            <Select
                              {...field}
                              labelId="Priority-label"
                              id="Priority"
                              displayEmpty
                              renderValue={(selected) => {
                                const selected_value =
                                  priorityOptions?.priority_details.find(
                                    (list) => list.priority_id === selected
                                  );
                                return selected_value ? (
                                  <span
                                    style={{
                                      color:
                                        selected_value.priority_colour ||
                                        "black",
                                    }}
                                  >
                                    {selected_value.priority_name}
                                  </span>
                                ) : (
                                  <span className=" lightText">
                                    Select priority
                                  </span>
                                );
                              }}
                              disabled={!canEditIssue}
                              value={nameChange.priority_id}
                              onChange={handleNameChange}
                              onBlur={handleBlur}
                              // {...control.register("priority_id")}
                              IconComponent={ExpandMore}
                            >
                              {priorityOptions?.priority_details?.map(
                                (list) => (
                                  <MenuItem
                                    key={list?.priority_id}
                                    sx={{
                                      color: list?.priority_colour || "black",
                                    }}
                                    value={list?.priority_id}
                                  >
                                    {list?.priority_name}
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </FormControl>
                        )}
                      />
                    </div>

                    <div className="col-md-4 pb-3">
                      <label htmlFor="Severity" className="form-label">
                        Severity
                      </label>
                      <FormControl fullWidth>
                        <Controller
                          name="severity_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              disabled={!canEditIssue}
                              labelId="Severity-label"
                              value={nameChange.severity_id}
                              id="Severity"
                              IconComponent={ExpandMore}
                              onChange={handleNameChange}
                              onBlur={handleBlur}
                              displayEmpty
                              renderValue={(selected) => {
                                const selected_value = serverityOptions?.find(
                                  (list) => list.severity_id === selected
                                );
                                return selected_value ? (
                                  <span
                                    style={{
                                      color:
                                        selected_value.severity_colour ||
                                        "black",
                                    }}
                                  >
                                    {selected_value.severity_name}
                                  </span>
                                ) : (
                                  <span className="lightText">
                                    Select severity
                                  </span>
                                );
                              }}
                            >
                              {serverityOptions.map((list) => (
                                <MenuItem
                                  key={list?.severity_id}
                                  value={list?.severity_id}
                                  sx={{ color: list?.severity_colour }}
                                >
                                  {list?.severity_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </div>

                    <div className="col-md-4 ">
                      <label htmlFor="Module" className="form-label">
                        Module
                      </label>
                      {showModel ? (
                        <>
                          <Controller
                            name="severity_id"
                            control={control}
                            render={({ field: { ref, value, onChange } }) => (
                              <FormControl fullWidth>
                                <Select
                                  displayEmpty
                                  inputRef={ref}
                                  value={nameChange.module}
                                  IconComponent={ExpandMore}
                                  onChange={(e) => {
                                    onChange(e.target.value);
                                    handleNameChange({
                                      target: {
                                        name: "module",
                                        value: e.target.value,
                                      },
                                    });
                                  }}
                                  onBlur={(e) => {
                                    handleBlur({
                                      target: {
                                        name: "module",
                                        value: e.target.value,
                                      },
                                    });
                                  }}
                                  disabled={!canEditIssue}
                                  renderValue={(selected) =>
                                    selected ? (
                                      selected
                                    ) : (
                                      <span className="lightText">
                                        Select module
                                      </span>
                                    )
                                  }
                                >
                                  {issue_module_dropdown &&
                                  issue_module_dropdown.length > 0 ? (
                                    issue_module_dropdown.map((list) => (
                                      <MenuItem key={list} value={list}>
                                        {list}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>
                                      No module found in this project
                                    </MenuItem>
                                  )}
                                </Select>
                              </FormControl>
                            )}
                          />
                        </>
                      ) : (
                        <>
                          <TextField
                            type="text"
                            id="module"
                            name="module"
                            placeholder="Enter module"
                            className="form-control"
                            value={nameChange.module}
                            onChange={handleNameChange}
                            onBlur={handleBlur}
                            disabled={!canEditIssue}
                          />
                        </>
                      )}

                      <div className=" text-end  mt-2">
                        <IconButton
                          onClick={() => setShowModel((prev) => !prev)}
                          sx={{
                            color: "rgba(18, 183, 159, 1)",
                            padding: "4px",
                            "&:hover": {
                              backgroundColor: "rgba(0, 0, 0, 0.06)",
                            },
                          }}
                        >
                          <CiCirclePlus fontSize={20} style={{ stroke: "currentColor", strokeWidth: 0.7 }} />
                        </IconButton>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <label htmlFor="module" className="form-label">
                        Module
                      </label>
                      <TextField
                        type="text"
                        id="module"
                        name="module"
                        placeholder="Enter module"
                        className="form-control"
                        value={nameChange.module}
                        onChange={handleNameChange}
                        onBlur={handleBlur}
                        disabled={
                          !["ADMIN", "MANAGER"].includes(login_user_role) && // ✅ Allow only ADMIN & MANAGER
                          login_user_name !== issue_detail?.assignee_name &&
                          selectedUser !== login_user_id
                        }
                      />
                    </div> */}

                  </div>
                </form>

              </LocalizationProvider>
              {isIssueDetail && (
                <IssueTabs
                  issue_id={id}
                  document_count={IssueDetail?.document_count}
                  comment_count={IssueDetail?.comment_count}
                  assignee_name={issue_detail?.assignee_name}
                  added_by={selectedUser}
                  login_user_name={login_user_name}
                  login_user_id={login_user_id}
                  login_user_role={login_user_role}
                  // logHours={IssueDetail?.total_log_hours}
                  logHours={totalCalculatedHours}
                />
              )}

              {isMilestoneIssueDetail && (
                <MilestoneIssueTabs
                  issue_id={id}
                  document_count={issue_detail?.document_count}
                  comment_count={issue_detail?.comment_count}
                  assignee_name={issue_detail?.assignee_name}
                  added_by={selectedUser}
                  login_user_name={login_user_name}
                  login_user_id={login_user_id}
                  login_user_role={login_user_role}
                  // logHours={IssueDetail?.total_log_hours}
                  logHours={totalCalculatedHours}
                />
              )}
            </div>
            
            <div className="col-md-3 p-3 border rounded">
              {isIssueDetail && (
                <div className="d-flex my-3 justify-content-between">
                  <button
                    onClick={handlePrevTaskNav}
                    className="nextPrevBtn"
                    disabled={currentIndex <= 0}
                  >
                    <ArrowBack />
                  </button>
                  <button
                    onClick={handleNextTaskNav}
                    className="nextPrevBtn"
                    disabled={currentIndex >= issuelist.length - 1}
                  >
                    <ArrowForward />
                  </button>
                </div>
              )}

              <div
                className="slider-container p-0"
                style={{ maxHeight: "900px", overflow: "hidden" }}
              >
                <div className="d-flex align-items-end justify-content-between">
                  <h4 className="mb-1">All Open Issues</h4>
                  <div className="arrows d-flex">
                    <button className="slick-prev" onClick={handlePrevClick}>
                      <FaChevronUp />
                    </button>
                    <button className="slick-next" onClick={handleNextClick}>
                      <FaChevronDown />
                    </button>
                  </div>
                </div>

                <Slider {...settings} ref={sliderRef}>
                  {issuelist?.map((task, index) => (
                    <div
                      key={index}
                      className={`border rounded p-3 mb-2 box ${
                        IssueDetail?.issue_id === task.issue_id ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleBoxClick(task.issue_id)}
                    >
                      <div className="d-flex align-items-center pb-3"> 
                        <div
                          className="pe-2 fw-bold truncated-text"
                          title={task.title}
                        >
                          {task.title}
                        </div>
                        {/* <div className="taskHighlight"></div> */}
                      </div>
                      <div className="d-flex align-items-center">
                        <label className="text-rgba-gray pe-2 d-flex align-items-center">
                          Owner
                        </label>
                        <label>{task.assignee}</label>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
